import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import JsonLd from "./JsonLd";
import { SITE_URL } from "@/hooks/useSeo";
import useI18n from "@/i18n";
import { pagePath } from "@/i18n/config";

/** Fil d'Ariane visible + BreadcrumbList schema.org. */
export default function PageBreadcrumb({ label, pageKey }) {
    const { t, lang } = useI18n();
    const home = pagePath(lang, "home");
    const path = pagePath(lang, pageKey);

    return (
        <>
            <JsonLd
                id={`ld-breadcrumb-${pageKey}`}
                data={{
                    "@context": "https://schema.org",
                    "@type": "BreadcrumbList",
                    itemListElement: [
                        { "@type": "ListItem", position: 1, name: t.common.home, item: `${SITE_URL}${home}` },
                        { "@type": "ListItem", position: 2, name: label, item: `${SITE_URL}${path}` },
                    ],
                }}
            />
            <nav aria-label={t.common.breadcrumbAria} className="text-sm text-ink2">
                <Link
                    to={home}
                    className="inline-flex items-center gap-1.5 font-semibold text-terrat transition-colors duration-200 hover:text-terrad"
                    data-testid="breadcrumb-home"
                >
                    <ArrowLeft size={15} aria-hidden="true" />
                    {t.common.home}
                </Link>
                <span aria-hidden="true" className="px-2">·</span>
                <span>{label}</span>
            </nav>
        </>
    );
}
